import * as React from 'react';

/** Material UI Packages. */
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';

/** Material UI Icons. */
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/** Internal Components. */
import TodoTable from './TodoTable';

/**
 * CategoryAccordion component to display the category's information and todo sections.
 * @param {Object} option - The category's information.
 * @param {Array} sections - The todo sections.
 * @param {Object} accordionStyle - The style of the accordion.
 * @param {Object} detailStyle - The style of the accordion details.
 * @returns {JSX.Element} The CategoryAccordion component.
 */
export default function CategoryAccordion({ option, sections, accordionStyle, detailStyle }) {
    /** Calculate the total row sum of the todo sections. */
    const sectionsLength = sections.reduce((acc, item) => {
        return acc + (Array.isArray(item.data) ? item.data?.length : 0);
    }, 0);

    return (
        <Accordion sx={{ border: 'none', ...accordionStyle }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    minHeight: 0,
                    bgcolor: option.color,
                    borderRadius: 1,
                    '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
                    '& .MuiAccordionSummary-content': { margin: 1 },
                    '&.Mui-expanded': { minHeight: 35 },
                }}
            >
                <Typography sx={{ fontSize: 12, fontWeight: 500 }}>{option.title}</Typography>
                <Typography
                    sx={{
                        fontSize: 10,
                        fontWeight: 400,
                        backgroundColor: '#fff',
                        borderRadius: '9.5px',
                        width: 20,
                        height: 19,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        ml: 1,
                    }}
                >
                    {sectionsLength}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0, margin: 0, height: 250, overflow: 'auto', ...detailStyle }}>
                {sections.map(({ id, data, config }) => (
                    <TodoTable
                        key={id}
                        data={data}
                        config={config}
                        type="taskboard"
                        tableStyle={{
                            fontSize: 10,
                            '& .MuiDataGrid-scrollbar': {
                                overflowY: 'hidden',
                            },
                        }}
                    />
                ))}
            </AccordionDetails>
        </Accordion>
    );
}
